"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.makeAuthRequests = void 0;

var makeAuthRequests = function makeAuthRequests(_ref) {
  var loginRequestFunction = _ref.loginRequestFunction,
      refreshTokenRequestFunction = _ref.refreshTokenRequestFunction,
      forgotPasswordRequestFunction = _ref.forgotPasswordRequestFunction,
      resetPasswordRequestFunction = _ref.resetPasswordRequestFunction;

  var saveTokens = function saveTokens(accessToken, refreshToken) {
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('refreshToken', refreshToken);
  };

  var deleteTokens = function deleteTokens() {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
  };

  var getAccessToken = function getAccessToken() {
    return localStorage.getItem('accessToken');
  };

  var getRefreshToken = function getRefreshToken() {
    return localStorage.getItem('refreshToken');
  };

  var getTokensFormResponseAndSave = function getTokensFormResponseAndSave(response) {
    var data = response.data;
    var accessToken = data.accessToken,
        refreshToken = data.refreshToken;
    saveTokens(accessToken, refreshToken);
    return data;
  };

  var logIn = function logIn(email, password) {
    return loginRequestFunction(email, password).then(getTokensFormResponseAndSave);
  };

  var logOut = function logOut() {
    deleteTokens();
    return Promise.resolve();
  };

  var refreshTokens = function refreshTokens() {
    var refreshToken = getRefreshToken();
    if (!refreshToken) return Promise.reject(new Error('No token in storage!'));
    return refreshTokenRequestFunction(refreshToken).then(getTokensFormResponseAndSave);
  };

  var sendForgotPasswordEmail = function sendForgotPasswordEmail(email) {
    return forgotPasswordRequestFunction(email);
  };

  var resetPassword = function resetPassword(password, data) {
    return resetPasswordRequestFunction(password, data);
  };

  var checkIfLoggedIn = function checkIfLoggedIn() {
    return refreshTokens();
  };

  return {
    getAccessToken: getAccessToken,
    refreshTokens: refreshTokens,
    logIn: logIn,
    logOut: logOut,
    sendForgotPasswordEmail: sendForgotPasswordEmail,
    resetPassword: resetPassword,
    checkIfLoggedIn: checkIfLoggedIn
  };
};

exports.makeAuthRequests = makeAuthRequests;
var _default = makeAuthRequests;
exports.default = _default;